var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7944 37.4857C23.7612 34.8551 25.6079 32.2046 28.0923 31.3278C26.1061 33.0549 24.731 35.0278 23.7944 37.4857Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3242 36.8147C19.4836 32.8821 22.1076 29.0425 25.7213 27.4814C22.6124 29.8928 20.4535 33.0548 19.3242 36.8147Z",
    fill: "#1D1D1B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0234 35.9778C14.4287 30.4509 18.0557 25.1632 23.0777 22.8116C18.5605 26.0135 15.3985 30.617 14.0234 35.9778Z",
    fill: "#1D1D1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3978 69.4643L68.1229 67.6707C66.1632 66.6012 65.4458 64.1434 66.5153 62.1837L71.5041 53.0631C72.5736 51.1034 75.0315 50.386 76.9911 51.4555L80.266 53.2491C82.2257 54.3186 82.9431 56.7764 81.8736 58.7361L76.8848 67.8567C75.8153 69.8164 73.3575 70.5404 71.3978 69.4643Z",
    fill: "#C4C4C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7182 56.0019L73.8848 51.7191L67.7347 62.968L75.5681 67.2508L81.7182 56.0019Z",
    fill: "#243B5F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.793 67.4848C71.237 67.4848 71.5968 67.1249 71.5968 66.681C71.5968 66.2371 71.237 65.8772 70.793 65.8772C70.3491 65.8772 69.9893 66.2371 69.9893 66.681C69.9893 67.1249 70.3491 67.4848 70.793 67.4848Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6243 57.9988L81.7137 56.006L73.8818 51.7213L70.4541 57.9988H80.6243Z",
    fill: "#4D5E88"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.738 47.6891H42.9127C39.3986 47.6891 36.5488 44.8394 36.5488 41.3253V27.6211C36.5488 24.107 39.3986 21.2572 42.9127 21.2572H63.738C67.2521 21.2572 70.1019 24.107 70.1019 27.6211V41.3186C70.1085 44.8394 67.2587 47.6891 63.738 47.6891Z",
    fill: "#EC6D77"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2791 31.0554H54.9229V43.1919H65.2791V31.0554Z",
    fill: "#FDDBB4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5789 31.0554H40.2227V43.1919H50.5789V31.0554Z",
    fill: "#FDDBB4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9229 43.1919C54.6439 39.0401 54.5841 34.8817 54.5974 30.7233C56.4308 30.7366 58.2643 30.7432 60.1043 30.8096C61.8315 30.8561 63.5586 30.9226 65.2858 31.0488C61.8381 31.2813 58.3838 31.361 54.9296 31.3743L55.2551 31.0488C55.2617 35.1076 55.1953 39.1531 54.9229 43.1919Z",
    fill: "#1D1D1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2227 43.1919C39.9437 39.0401 39.8839 34.8817 39.8972 30.7233C41.7307 30.7366 43.5641 30.7432 45.4041 30.8096C47.1313 30.8561 48.8584 30.9226 50.5856 31.0488C47.1379 31.2813 43.6836 31.361 40.2294 31.3743L40.5549 31.0488C40.5615 35.1076 40.4951 39.1531 40.2227 43.1919Z",
    fill: "#1D1D1B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6772 21.2572H38.9801C37.6383 21.2572 36.5488 22.3466 36.5488 23.6885V27.641H70.1085V23.6885C70.1085 22.3466 69.0191 21.2572 67.6772 21.2572Z",
    fill: "#C23C4F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7602 24.4656C42.7469 25.9735 40.4817 26.0665 40.4219 24.4656C40.4817 22.858 42.7469 22.9577 42.7602 24.4656ZM42.7602 24.4656C42.7137 23.2965 41.0928 23.3895 41.0862 24.4656C41.0928 25.5417 42.7137 25.6347 42.7602 24.4656Z",
    fill: "#1D1D1B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4857 24.4656C48.4725 25.9735 46.2072 26.0665 46.1475 24.4656C46.2072 22.858 48.4725 22.9577 48.4857 24.4656ZM48.4857 24.4656C48.4392 23.2965 46.8184 23.3895 46.8117 24.4656C46.8117 25.5417 48.4392 25.6347 48.4857 24.4656Z",
    fill: "#1D1D1B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2822 76.2268H70.2945H75.084H87.9313C87.9313 78.8906 85.7724 81.0429 83.1152 81.0429H17.331C15.5108 81.0429 14.0361 79.5682 14.0361 77.748V76.2268H63.5985H66.2822Z",
    fill: "#1F9B9E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3036 64.934L63.5984 76.2269H14.0361L3.78613 42.7203L25.9666 42.242L47.0843 41.7903L49.9341 41.7305L53.5079 41.6508L60.3036 64.934Z",
    fill: "#6CC3C6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2838 64.1762C35.8472 63.9151 36.8519 62.1311 36.5281 60.1914C36.2042 58.2517 34.6743 56.8908 33.111 57.1519C31.5476 57.4129 30.5428 59.197 30.8667 61.1367C31.1906 63.0764 32.7205 64.4372 34.2838 64.1762Z",
    fill: "#FEFFFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5228 60.1909C37.2402 65.0933 31.5008 65.9968 30.5309 61.1873C29.8932 56.3248 35.6127 55.3217 36.5228 60.1909ZM36.5228 60.1909C35.6326 55.8133 30.5376 56.6171 31.1886 61.0811C32.0256 65.5185 37.1074 64.6151 36.5228 60.1909Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopIcon);
export default __webpack_public_path__ + "static/media/laptop-icon.64fbac382cffd00669008b390ff3dc85.svg";
export { ForwardRef as ReactComponent };